import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Button,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip as rToolTip,
  Cell,
} from "recharts";

export default function OpsActivityRecordsPage() {
  const pageTitle = "Activity Records";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [logs, setLogs] = useState([]);

  const [days, setDays] = useState(60);
  const [activity, setActivity] = useState(null);

  const logsTableColumns = [
    { Header: "Actions", accessor: "actions", align: "left" },
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Territory", accessor: "territory", align: "left" },
    { Header: "Date", accessor: "created", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        agent: row.agent,
        territory: row.territory,
        actions: (
          <MDBox mt={1} variant="button" display="flex" gap={0.5}>
            <Tooltip title="View Activity Record">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  navigate(`/ops/activities/records/${row.reference}`);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                  east
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);

      await axios
        .get(`/portal/ops/activities/${ref}/records.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setActivity(result.data.data.activity);
            const rows = buildRows(result.data.data.records);
            setLogs(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage, days]);

  const COLORS = ["#1976d2", "#43a047", "#fb8c00", "#8e24aa", "#e53935", "#00897b", "#3949ab"];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <MDBox pb={3}>
        {pageLoaded && (
          <MDBox>
            <MDBox mt={1} mb={1.5}>
              <MDBox display="flex" justifyContent="space-between" alignItems="center">
                <MDBox>
                  <Button
                    color="dark"
                    startIcon={<Icon>west</Icon>}
                    onClick={() => {
                      navigate(`/ops/activities`);
                    }}
                  >
                    Back
                  </Button>
                </MDBox>
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    {activity.title}
                  </MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>
            <MDBox mb={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Records
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <MDBox mt={0}>
                    <DataTable
                      table={{ columns: logsTableColumns, rows: logs }}
                      isSorted
                      canSearch
                      entriesPerPage
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
